export const dateTimeFormat = (epoch: number) =>
  new Date(epoch * 1000).toLocaleString(navigator.languages[0], {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    timeZoneName: "short",
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  });
